<template lang="pug">
    f-dashboard-user-sulteng(v-if="userRole" :userDetail="userDetail")
    f-dashboard-admin-sulteng(v-else-if="userAdmin" :userDetail="userDetail")
</template>
<script>
export default {
    name: "FDashboardSulteng",
    data() {
        return {
            userDetail: null
        }
    },
    mounted() {
        this.$session.userDetail().then(item => {
            this.userDetail = item || null;
        });
    },
    computed: {
        userRole(){
            return this.userDetail && this.userDetail.user && 
                (this.userDetail.user.roleId == 'OPR_USER' || this.userDetail.user.roleId == 'VRF_USER' || this.userDetail.user.roleId == 'APR_USER')     
        },
        userAdmin(){
            return this.userDetail && this.userDetail.user && 
                (this.userDetail.user.roleId == 'ADM_CORPORATE' || this.userDetail.user.roleId == 'SPV_CORPORATE' || this.userDetail.user.roleId == 'OPR_CORPORATE')     
        }
    },
    methods: {
        
    },
}
</script>